// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentMethod_root__1GyVQ","content":"PaymentMethod_content__2djGo","card":"PaymentMethod_card__e9Kag"};